import React, { useState } from 'react';
import Button from 'components/DesignSystem/Button';
import { useClosure } from 'utils/hooks';
import InstructionsModal from '../InstructionsModal';

export default function SeasonalComparatorToolbar({
  downloadDisabled,
  onDownloadClick,
}: {
  downloadDisabled: boolean;
  onDownloadClick: () => void;
}) {
  const [showInstructions, setShowInstructions] = useState(false);

  return (
    <>
      <InstructionsModal
        show={showInstructions}
        onHide={useClosure(setShowInstructions, false)}
      />
      <div className="d-flex">
        <Button
          id="seasonal-comparator-download-button"
          className="me-2"
          small
          icon="download"
          onClick={onDownloadClick}
          disabled={downloadDisabled}
        />
        <Button
          id="seasonal-comparator-instructions-button"
          small
          icon="help"
          onClick={useClosure(setShowInstructions, true)}
        />
      </div>
    </>
  );
}
